module.exports = __webpack_public_path__ + "static/DS-61c3fdc0bfc17ff5eb67e50f192f88a3.jpg";